// sidebarLockReducer.js
const initialState = {
  isLocked: false
};

export const sidebarLockReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOCK_SIDEBAR":
      return { ...state, isLocked: true };
    case "UNLOCK_SIDEBAR":
      return { ...state, isLocked: false };
    default:
      return state;
  }
}
